<template>
  <DatePicker
    :type="type"
    :transfer="transfer"
    :placeholder="placeholder"
    :placement="placement"
    :format="format"
    :options="options"
    :value="currValue"
    @on-change="onChange"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'datetime'
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    format: {
      type: String,
      default: 'yyyy/MM/dd'
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currValue: ''
    }
  },
  watch: {
    value(val) {
      this.currValue = this.value ? this.value : ''
    },
    currValue(val) {
      this.onChange(val)
    }
  },
  methods: {
    onChange(val) {
      let value = val
      if (this.format && value.constructor !== 'Date' && value) {
        value = new Date(value).format(this.format)
      }

      this.$emit('input', value)
      this.$emit('on-change', value)
    }
  },
  created() {
    if (this.value) {
      if (this.format && this.value.constructor !== 'Date' && this.value) {
        this.currValue = new Date(this.value).format(this.format)
      } else {
        this.currValue = this.value ? this.value : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SmyDatePicker.vue